export default __webpack_public_path__ + "static/media/landing page with no_background 1.216a6975.png";